export enum ErknmApproveRemarkFieldCodeEnum {
  KIND_KNM = 'KIND_KNM',
  START_DATE = 'START_DATE',
  STOP_DATE = 'STOP_DATE',
  DIRECT_DURATION_DAYS = 'DIRECT_DURATION_DAYS',
  DURATION_HOURS = 'DURATION_HOURS',
  REASON = 'REASON',
}
